import { Injectable } from '@angular/core';
import { ApiHttpClient } from '../modules/tcm-core.module';
import { WorkerJobEnum, ServiceTypeEnum } from '../models/enums';
import { AppriseTestResponse, SmsMessageModel, ServiceInfoViewModel, SqlTaskInfoViewModel } from '../models/external-services-info';
import { AppriseTestCallRequestModel } from '../models/apprise';
import { SqlTaskEnum } from '../models/enums/sql-task-enum';
import { SqlTaskExecutionRequestModel } from '../models/sql-task/sql-task-execution-request-model';

@Injectable({
  providedIn: 'root'
})
export class ExternalServiceInfoDataService {

  constructor(private readonly httpClient: ApiHttpClient) {
  }

  public getServices(cancellaiton: Promise<any>): Promise<ServiceInfoViewModel[]> {
    return this.httpClient.getJsonAsync<ServiceInfoViewModel[]>('ExternalServicesInfo/GetServices', null, cancellaiton);
  }

  public getServiceStatus(serviceType: ServiceTypeEnum, instanceId: number, cancellaiton: Promise<any>): Promise<ServiceInfoViewModel> {
    return this.httpClient.getJsonAsync<ServiceInfoViewModel>('ExternalServicesInfo/CheckServiceIsOperational', { serviceType: serviceType, instanceId: instanceId }, cancellaiton);
  }  

  public sendTestMailAsync(cancellationToken: Promise<any>): Promise<any> {
    return this.httpClient.postJsonAsync('ExternalServicesInfo/TestMailSettings', null, cancellationToken);
  }

  public sendSms(phoneNumber: string, smsText: string, cancellationToken: Promise<any>): Promise<boolean> {
    var data = { phoneNumber: phoneNumber, smsText: smsText } as SmsMessageModel;
    return this.httpClient.postJsonAsync<boolean>('ExternalServicesInfo/SendSMS', data, cancellationToken);
  }

  public testApprise(request: AppriseTestCallRequestModel): Promise<AppriseTestResponse> {
    return this.httpClient.getJsonAsync('ExternalServicesInfo/TestApprise', request);
  }

  //public triggerWorkerJob(workerJob: WorkerJobEnum, cancellationToken: Promise<any>): Promise<any> {
  //  return this.httpClient.postJsonAsync('ExternalServicesInfo/TriggerWorkerJob', workerJob, cancellationToken);
  //}

  public triggerOIJob(cancellationToken: Promise<any>): Promise<any> {
    return this.httpClient.postJsonAsync('ExternalServicesInfo/TriggerOIJob', cancellationToken);
  }
  public triggerERPJob(cancellationToken: Promise<any>): Promise<any> {
    return this.httpClient.postJsonAsync('ExternalServicesInfo/TriggerERPJob', cancellationToken);
  }
  
  public triggerClaimsJob(cancellationToken: Promise<any>): Promise<any> {
    return this.httpClient.postJsonAsync('ExternalServicesInfo/TriggerClaimsJob', cancellationToken);
  }
  
  public triggerExternalApiJob(cancellationToken: Promise<any>): Promise<any> {
    return this.httpClient.postJsonAsync('ExternalServicesInfo/TriggerExternalApiJob', cancellationToken);
  }
  public triggerERPErrorReport(cancellationToken: Promise<any>): Promise<any> {
    return this.httpClient.postJsonAsync('ExternalServicesInfo/TriggerERPErrorReport', cancellationToken);
  }

  public async testDocumentGenerator(cancellationToken: Promise<any>): Promise<any> {
    try {
      const response = await this.httpClient.getFileAsync('DocumentTemplates/TestDocumentGenerator');      
      response.save();
      return true;
    } catch {
      return false;
    }
  }

  public getSqlTasks(cancellaiton: Promise<any>): Promise<SqlTaskInfoViewModel[]> {
    return this.httpClient.getJsonAsync<SqlTaskInfoViewModel[]>('ExternalServicesInfo/GetSqlTasks', null, cancellaiton);
  }

  public getSqlTaskLastExecutionDetails(value: SqlTaskEnum, cancellation: Promise<any>): Promise<SqlTaskInfoViewModel> {
    return this.httpClient.getJsonAsync<SqlTaskInfoViewModel>('ExternalServicesInfo/GetSqlTaskLastLogDetails', { value: value }, cancellation);
  }

  public executeSqlTaskAsync(request: SqlTaskExecutionRequestModel): Promise<any> {
    return this.httpClient.getJsonAsync('ExternalServicesInfo/ExecuteSqlTask', request);
  }

}
